module.exports = __webpack_public_path__ + "img/43.4692895d.jpg";